import React from 'react'
import * as EmailUtils from '@/checkout-instore-legacy/utils/EmailUtils'
import IdentificationInput from '@/checkout-instore-legacy/components/Identification/components/IdentificationInput'
import { injectIntl } from 'react-intl'
import { useLocalizationState } from '@vtexlab/assisted-sales-localization'

const clearEmail = (email) => EmailUtils.clearIfInStoreAnonymousEmail(email)

const UnifiedInput = injectIntl(
  ({ countryCode, getInitialValue, intl, ...rest }) => {
    const localizationState = useLocalizationState({
      countryCode,
    })

    const isValidIdentification = (identificationText) => {
      if (
        localizationState.localizationConfig.input.document.validate(
          identificationText
        )
      ) {
        return true
      }

      if (EmailUtils.validateEmail(identificationText)) {
        return true
      }
      return false
    }

    const getMask = (identificationText) => {
      if (
        localizationState.localizationConfig.input.document.validate(
          identificationText
        )
      ) {
        return localizationState.localizationConfig.input.document.format(
          identificationText
        )
      }

      if (EmailUtils.validateEmail(identificationText)) {
        return clearEmail(identificationText)
      }

      return identificationText
    }

    return (
      <IdentificationInput
        inputType="text"
        placeholder={intl.formatMessage({ id: 'identificationPlaceHolder' })}
        mask={getMask}
        initialValue={getInitialValue()}
        normalize={clearEmail}
        validate={isValidIdentification}
        errorMessage={intl.formatMessage({ id: 'errorInvalidIdentification' })}
        {...rest}
      />
    )
  }
)

export default UnifiedInput
